import React from "react";
import { Box, Typography } from "@mui/material";

const SectionHeader = ({ number, title, description }) => {
  return (
    <Box
      sx={{
        mb: 10,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { md: "flex-end" },
        justifyContent: "space-between",
        gap: 4,
      }}
    >
      <Box>
        <Typography
          sx={{
            fontFamily: "mono",
            color: "primary.main",
            fontSize: "0.875rem",
            mb: 2,
            letterSpacing: "0.3em",
            textTransform: "uppercase",
          }}
        >
          {`${number} // ${title}`}
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            fontSize: { xs: "2.25rem", md: "3rem" },
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default SectionHeader;
